<template>
  <div class="d-flex market-header">
    <v-fade-transition v-if="!hideControls">
      <v-icon v-if="open" class="flex-0" size="14">mdi-minus</v-icon>
      <v-icon v-else class="flex-0" size="14">mdi-plus</v-icon>
    </v-fade-transition>
    <v-sheet tile class="primary py-2 px-4 pr-2 padding-fix word-break">
      <div class="d-flex" style="height: 100%">
        <span
          class="align-self-center white--text font-weight-bold text-uppercase premium-title"
        >
          {{ title === 'BOOKMAKER' ? 'MATCH WINNER (BOOKMAKER)' : title }}
        </span>
      </div>
    </v-sheet>
    <play-icon v-if="bookmaker" name="fast" text="Instant Betting"></play-icon>
    <div
      v-if="
        $auth.loggedIn &&
        (title === 'Match Odds' || title === 'BOOKMAKER') &&
        market.runners.length === 2
      "
      class="action"
      @click="cashOut(marketId)"
    >
      <span class="cash-out">
        <i
          aria-hidden="true"
          class="v-icon notranslate mdi mdi-currency-rupee"
        ></i
        ><span class="cash-out-amount theme--light">{{
          cashOutCalculation()?.possibleCashout
        }}</span>
        <div class="cash-out-text">Cash Out</div>
      </span>
    </div>
    <!-- Popup -->
    <div v-if="showPopup" class="popup Modal-Background">
      <div class="popup-card">
        <div class="popup-header">
          <v-icon class="popup-close" @click="showPopup = false"
            >mdi-close</v-icon
          >
        </div>
        <div class="popup-content">
          <p>Are you sure you want to cash out?</p>
          <div class="popup-actions">
            <button class="cancel-btn" @click="showPopup = false">
              Cancel
            </button>
            <button class="confirm-btn" @click="confirmCashOut">Confirm</button>
          </div>
        </div>
      </div>
    </div>
    <span class="mr-1"></span>
    <play-icon
      v-if="delayTime"
      name="timer"
      text="Timer"
      color="white"
      :delay-time="delayTime"
    >
    </play-icon>
    <span class="mr-1"></span>
    <play-icon
      v-if="bookmakerCommmission"
      name="commission"
      text="Commission"
      :max-commission="maxCommission"
      :text-commission="textCommission"
    ></play-icon>
    <v-spacer />
    <v-fade-transition>
      <v-sheet
        v-if="hideControls || open"
        :class="{
          'odds-title-width-xs-2': $breakpoint.xsOnly && !oneTitle,
          'odds-title-width-xs-1': $breakpoint.xsOnly && oneTitle,
          'odds-title-width-smAndUp': $breakpoint.smAndUp
        }"
        color="transparent"
      >
        <v-row no-gutters>
          <v-col
            v-for="(text, i) in sideText"
            :key="i"
            cols="6"
            class="caption px-3 py-3 font-weight-bold white--text"
            :class="{
              'text-center': $breakpoint.xsOnly,
              'text-right': $breakpoint.smAndUp && i === 0
            }"
          >
            {{ text }}
          </v-col>
        </v-row>
      </v-sheet>
    </v-fade-transition>
    <loader :loader-status="isLoader"></loader>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import PlayIcon from '@/components/icons/PlayIcon'
import apiService from '@/services/apiService'
import loader from '@/components/loading'

export default {
  name: 'SimpleBar',
  components: { PlayIcon, loader },
  props: {
    title: { type: String, default: '', required: true },
    hideControls: { type: Boolean, default: false, required: false },
    open: { type: Boolean, default: false, required: false },
    bookmaker: { type: Boolean, default: false, required: false },
    bookmakerCommmission: { type: Boolean, default: false, required: false },
    oneTitle: { type: Boolean, default: false, required: false },
    maxCommission: { type: Number, required: false, default: undefined },
    delayTime: { type: Number, required: false, default: undefined },
    sideText: { type: Array, default: () => ['Back', 'Lay'] },
    marketId: { type: [String, Number], default: 0, required: false },
    market: { type: Object, default: () => {}, required: false }
  },
  data() {
    return {
      textCommission: true,
      color: 'white',
      showPopup: false,
      localMarketId: this.marketId,
      isLoader: false
    }
  },
  computed: {
    ...mapState({
      pnlBySelection: (state) => state.betBooks.data
    })
  },
  methods: {
    showSnackbar({ content, color }) {
      this.$store.commit('snackbar/open', {
        text: content,
        color
      })
    },
    cashOut(marketId) {
      this.showPopup = true
      this.localMarketId = marketId
    },
    cashOutCalculation() {
      try {
        let favRunner = 0
        let lowestBackOdd = 1000.0
        let lowestLayOdd = 1000.0
        let possibleCashout = 0
        let betAmount = 0
        let betType1 = 'B'
        let totalAmount = 0
        if (!this.market || !this.market.runners) {
          possibleCashout = 0
          return { possibleCashout }
        }
        this.market.runners.forEach((runner) => {
          if (runner?.back?.length > 0) {
            const backPrice = runner?.back?.[0]?.price
            if (lowestBackOdd > backPrice) {
              lowestBackOdd = backPrice
              favRunner = runner?.id
            }
          }

          if (runner?.lay?.length > 0) {
            const layPrice = runner?.lay?.[0]?.price
            if (lowestLayOdd > layPrice) {
              lowestLayOdd = layPrice
              favRunner = runner?.id
            }
          }
        })
        if (favRunner === 0) {
          return { possibleCashout }
        }
        const runnerId =
          (this.pnlBySelection && Object.entries(this.pnlBySelection)) || []
        let favExpo = 0
        runnerId?.forEach((item) => {
          const [marketPrefix, runnerPrefix] = item[0].split('-')
          const pnl = Number(item[1]?.pnl) || 0
          // console.log('item', pnl)
          if (marketPrefix === this.market.id) {
            if (favRunner.toString() === runnerPrefix) {
              if (pnl > 0) {
                betType1 = 'L'
              }
              favExpo = pnl
            }
            totalAmount += Math.abs(pnl)
          }
        })

        if (betType1 === 'L') {
          // lowestLayOdd !== 0
          //   ? (betAmount = totalAmount / Number(lowestLayOdd))
          //   : (betAmount = 0)
          // possibleCashout = favExpo - (lowestLayOdd - 1) * betAmount
          betAmount =
            Math.round((totalAmount / Number(lowestLayOdd)) * 100) / 100
          possibleCashout = favExpo - (lowestLayOdd - 1) * betAmount
        } else {
          // lowestBackOdd !== 0
          //   ? (betAmount = totalAmount / Number(lowestBackOdd))
          //   : (betAmount = 0)
          // possibleCashout = favExpo - (lowestBackOdd - 1) * betAmount
          betAmount =
            Math.round((totalAmount / Number(lowestBackOdd)) * 100) / 100
          possibleCashout = favExpo + (lowestBackOdd - 1) * betAmount
        }
        betAmount = Math.round(betAmount * 100) / 100

        if (possibleCashout !== 0) {
          possibleCashout = Number(possibleCashout.toFixed(2))
          return { possibleCashout }
        }

        return { possibleCashout }
      } catch (error) {
        console.log('Error calculating cashout', error)
      }
    },
    confirmCashOut() {
      this.isLoader = true
      apiService
        .apiCallWithCashoutGet(
          `/exchange/order/cashout?marketId=${this.localMarketId}`
        )
        .then(async (response) => {
          this.isLoader = false
          if (response?.data?.success) {
            await this.$store.dispatch(
              'betBooks/get',
              this.market?.event?.id,
              this.refresh
            )
            this.showSnackbar({
              content: 'Cash out successfully',
              color: 'success'
            })
          } else {
            this.showPopup = false
            this.showSnackbar({
              content:
                response?.data?.error?.[0]?.[0]?.description ||
                response?.data?.status?.statusDesc,
              color: 'error'
            })
            return
          }
          const sizeMatched = response?.result?.sizeMatched
          if (sizeMatched) {
            this.showSnackbar({
              content: `Cash out successful. Amount: ${sizeMatched}`,
              color: 'success'
            })
          }
          this.showPopup = false
        })
        .catch((error) => {
          this.isLoader = false
          this.showPopup = false
          this.showSnackbar({
            content: `Cash out failed ${error?.response?.data?.error[0][0].description}`,
            color: 'error'
          })
        })
    }
  }
}
</script>
<style scoped>
.popup {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0 12px;
}
.popup-card {
  width: 100%;
  border: 1px solid #f36c21;
  border-radius: 7px;
  padding: 12px;
  background: #212121;
}
.popup-header {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.popup-title {
  font-size: 1.2rem;
  font-weight: 700;
  color: #f36c21;
}
.cash-out-amount {
  font-size: 0.75rem;
  font-weight: 700;
  color: #f36c21;
  /* background: #fff; */
}
.popup-close {
  cursor: pointer;
  color: #f36c21;
}
.popup-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 12px;
}
.popup-content p {
  font-size: 1rem;
  color: #fff;
  font-weight: 700;
}
.popup-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 70%;
}
.popup-actions button {
  padding: 8px 16px;
  border-radius: 4px;
  color: #fff;
  font-weight: 700;
  cursor: pointer;
  width: 50%;
}
.confirm-btn {
  background: #f36c21;
  font-size: 15px !important;
}
.cancel-btn {
  background: #6b6a6a;
  font-size: 15px !important;
}
.v-sheet .word-break {
  word-break: break-all;
  border-top-left-radius: 16px !important;
}
.cash-out {
  align-items: center;
  color: inherit;
  display: flex;
  flex: 1 0 auto;
  padding-right: 4px !important;
  justify-content: inherit;
  line-height: normal;
  position: relative;
  transition: inherit;
  transition-property: opacity;
  font-size: 0.5rem;
  font-weight: 700;
  text-transform: uppercase;
}
.market-header {
  background-color: rgb(39, 39, 39);
  align-items: center;
  gap: 2px;
  border-radius: 16px 16px 0px 0px !important;
  justify-content: space-between;
}
.action {
  align-items: center;
  display: flex;
  /* margin: 8px; */
  border-radius: 4px;
  padding-right: 4px !important;
  height: 34px;
  background: linear-gradient(0deg, #c6a352 0%, #f3e88a 50%, #c6a352 85%);
}
.v-icon.mdi.mdi-currency-rupee {
  font-size: 14px;
}
.action::before {
  background-color: currentColor;
  border-radius: inherit;
  bottom: 0;
  color: inherit;
  content: '';
  left: 0;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
  transition: opacity 0.2s cubic-bezier(0.4, 0, 0.6, 1);
}
.cash-out-text {
  padding: 0 2px;
  height: 24px !important;
  display: inline-flex !important;
  align-items: center;
  border-radius: 0px 4px 4px 0px;
  /* background: #f3e88a; */
  /* background: linear-gradient(0deg, #c6a352 0%, #f3e88a 50%, #c6a352 85%); */
}
.mdi.mdi-currency-rupee.theme--light {
  font-size: 0.8rem !important;
  padding: 0 3px;
  height: 24px !important;
  background: #fff;
  border-radius: 4px 0px 0px 4px;
  max-width: 8px;
}
</style>
